import { ArrowRight } from "lucide-react";
import { FadeUp, SectionHeading } from "./Reveal";

const SERVICES = [
  { name: "Architectural Design", desc: "Concept to construction documents" },
  { name: "Custom Homes", desc: "Ground-up residential, drawn and built by us" },
  { name: "Commercial Build-Out", desc: "Offices, retail, and hospitality interiors" },
  { name: "Renovation + Additions", desc: "Structural rework, done surgically" },
  { name: "Permitting + Entitlements", desc: "We navigate the city so you don't have to" },
  { name: "Construction Management", desc: "Schedule, budget, and site — owned end to end" },
];

export const Services = () => (
  <section id="services" className="px-6 md:px-12 py-28 md:py-40" data-testid="services-section">
    <SectionHeading index="What We Do" title="Services" testId="services-heading" />
    <div>
      {SERVICES.map((s, i) => (
        <FadeUp key={s.name} delay={i * 0.06}>
          <div
            className="group flex items-center justify-between gap-6 border-t border-white/15 last:border-b py-7 md:py-9 px-2 md:px-4 cursor-pointer hover:bg-white transition-colors duration-400"
            data-testid={`service-row-${s.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          >
            <div className="flex items-baseline gap-6 md:gap-10">
              <span className="text-xs tracking-[0.3em] text-ash group-hover:text-black/50 transition-colors duration-300">
                {String(i + 1).padStart(2, "0")}
              </span>
              <h3 className="font-display text-xl sm:text-2xl md:text-4xl uppercase font-bold tracking-tight group-hover:text-black transition-colors duration-300">
                {s.name}
              </h3>
            </div>
            <div className="flex items-center gap-6 md:gap-10">
              <span className="hidden md:block text-sm font-light text-ash group-hover:text-black/60 transition-colors duration-300">
                {s.desc}
              </span>
              <ArrowRight
                size={24}
                strokeWidth={1.5}
                className="shrink-0 text-ash group-hover:text-black group-hover:translate-x-2 transition-all duration-400"
              />
            </div>
          </div>
        </FadeUp>
      ))}
    </div>
  </section>
);
